(function(){
  const map = {'ă':'a','â':'a','î':'i','ș':'s','ț':'t','Ă':'A','Â':'A','Î':'I','Ș':'S','Ț':'T'};
  const replace = s => s.replace(/[ăâîșțĂÂÎȘȚ]/g, c => map[c] || c);

  function processNode(el) {
    if (el.nodeType === 3) {
      el.textContent = replace(el.textContent);
    } else if (el.nodeType === 1) {
      ['value','placeholder','title','alt','aria-label'].forEach(attr => {
        if (el.hasAttribute(attr)) {
          el.setAttribute(attr, replace(el.getAttribute(attr)));
        }
      });
      el.childNodes.forEach(processNode);
    }
  }

  new MutationObserver(muts => {
    muts.forEach(m => m.addedNodes.forEach(n => processNode(n)));
  }).observe(document.documentElement, {childList:true,subtree:true});

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => document.body && processNode(document.body));
  } else {
    document.body && processNode(document.body);
  }
})();
